import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';


const Login = () => {
     const { t, i18n } = useTranslation();
    const modalRef = useRef(null);


  return (  
                <div ref={modalRef} className="modal video-show-modal trainer-show-modal login-modal fade" id="trainerModal" aria-labelledby="trainerModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                <Link to="#"><img src="img/CfaN.png" alt=""/></Link>
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center registration-text">
                        
                           <p>{t("Are_you_a_registered_trainer")} {t("If_yes_please")} <span data-bs-toggle="modal" data-bs-target="#loginModal">{t("login")}</span>.</p>
                        </div>
                        </div>
                    </div>
                    </div>
  );
};

export default Login;